import React from "react";
import { connect } from "react-redux";
import { MapContainer, TileLayer, Marker, Popup, Tooltip } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import moment from "moment";
import L from 'leaflet';
import $ from "jquery";
import { withTranslation } from "react-i18next";
import i18n from "./DropdownLanguage/i18n";

class MapChart extends React.Component {
    constructor() {
        super();
        this.state = {
            searchData: {},
            markers: [],
            // idorg: 0,
        };
        this.mapRef = React.createRef();
        this.onClickUserLoc = this.onClickUserLoc.bind(this);
        this.clickAction = this.clickAction.bind(this);
        this.markerRefs = [];
    }

    componentDidMount() {
        const { ShipId } = this.props;
        // $(document).on("blur",".popup_close",function(){
        // })
        // if (ShipId) {
        //     $(document).on('click', function (e) {
        //         if ($(e.target).closest(".leaflet-popup").length === 0) {
        //             $(".leaflet-popup").hide();
        //         }
        //     });
        // }
    }

    componentDidUpdate() {
        const { ShipId } = this.props;
        var lat = $(`#ship${ShipId}`).data("lat");
        var lng = $(`#ship${ShipId}`).data("lng");
        if (ShipId) {
            window.scroll(0, 200);
            this.clickAction(ShipId, lat, lng);
            this.props.dispatch({ type: "MapPopup", data: 0 });
        }
        let _this = this;
        $(document).on('click', function (e) {
            let length = $(".leaflet-popup-pane").children().length;
            if ($(e.target).closest(".leaflet-marker-pane").length === 0 && length > 0) {
                if (ShipId === 0) {
                    let OrgshipId = $(".leaflet-popup-content p").first().attr("id");
                    let id = parseInt(OrgshipId);
                    _this.markerRefs[id].closePopup();
                }
                else {
                    _this.markerRefs[ShipId].closePopup();
                }
                // $(".leaflet-popup").hide();
            }
        });
    }

    onClickUserLoc() {
        this.mapRef.current.leafletElement.flyTo();
    }

    clickAction(id, lat, lng) {
        console.log(this.markerRefs[id])
        this.markerRefs[id].openPopup({ lat: lat, lng: lng });
    }

    render() {
        const { markers,t } = this.props;
        const isArabic = i18n.language === 'arab'
        let width = window.innerWidth;
        return (
            <>
                <MapContainer id="map_canvas"
                    center={width > 820 ? [-0.5937, -5.9629] : [-50.5937, -5.9629]}
                    zoom={1}
                    scrollWheelZoom={true}
                    maxZoom={25}
                    minZoom={2}
                    style={{ height: "80vh" }}
                    ref={this.mapRef}
                    worldCopyJump={true}
                    maxBounds={[[100.5937, -200.9629], [-100.5937, 200.9629]]}
                >
               {/*  <TileLayer
                        url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager_labels_under/{z}/{x}/{y}{r}.png"
                    />  */}
                  {/*   <TileLayer url="http://mt0.google.com/vt/lyrs=m&r&tl=en&x={x}&y={y}&z={z}"/> */}
                  {/*   <TileLayer url="http://mt.google.com/vt/lyrs=m&y&l=en&x={x}&y={y}&z={z}"/> */}
                  {/*  <TileLayer url="https://mt.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"/> */}
                   <TileLayer url="https://mt0.google.com/vt/lyrs=r&s&tl=en&x={x}&y={y}&z={z}"/>
                   
                    {markers.length !== 0 && markers.map((item, index) => (
                        <Marker
                            id={item.shipId}
                            key={index}
                            ref={ref => this.markerRefs[item.shipId] = ref}
                            position={[item.lastPositionUpdate?.latitude ?? 0, item.lastPositionUpdate?.longitude ?? 0]}
                            icon={
                                new L.divIcon({
                                    html:
                                        `<input type="hidden" id="ship${item.shipId}" data-lat=${item.lastPositionUpdate?.latitude ?? 0} data-lng=${item.lastPositionUpdate?.longitude ?? 0}>
                                                <svg height="15" viewBox="-5.1 -9.1 10.2 24.2" style="transform: rotate(${item.lastPositionUpdate?.heading}deg);">
                                        <path d="m 0 -9 C 2 -7 4 -3 5 0 L 5 13 L 0 8 L -5 13 L -5 0 C -4 -3 -2 -7 0 -9" fill="${item.markerColor}FE" stroke="${item.markerColor}FF" ></path>
                                        </svg>`,
                                    className: 'leaflet-div-icon'
                                })
                            }
                        >
                            <Popup autoClose={true} closeButton={false}>
                                <>
                                    <p className="font-weight-bold text-uppercase lead" id={item.shipId}>{item.shipName}</p>
                                    <p>{t('ComplianceandBudgetScreen.Type')} : <span className="text-uppercase">{item.type}</span> </p>
                                    <p className="item-details">
                                        <span>{t('TopPaneContent.Flag')}: {item.flag}</span> |&nbsp;<span className={` ${isArabic ? 'arabic' : ''}`}>{t('content.IMOno')}<span>:</span>{item.imo}</span>
                                    </p>
                                    <p className="item-details"> {t('Map.MMSI')}: {item.mmsi} |&nbsp;<span className={` ${isArabic ? 'arabic' : ''}`}> {t('Map.CallSign')} <span>:</span>{item.callsign} </span> </p>
                                    <p> {t('Map.AISClass')} : {item.aisClass} |&nbsp;<span className={` ${isArabic ? 'arabic_ship' : ''}`}> {t('Map.Draught')} <span>:</span> {item.draught} <span>m</span></span> </p>
                                    <p> {t('content.Destination')} : <span className="font-weight-bold">{item.destination} </span> </p>
                                    <p> {t('Map.NavigationalStatus')} : <span className="font-weight-bold">{item.lastPositionUpdate?.navigationalStatus} </span> </p>
                                    <p className={` ${isArabic ? 'arabic' : ''}`}> {t('content.ETA')} <span>:</span> <span className="font-weight-bold">{item.eta ? moment(item.eta).format("DD MMM YYYY") : ""}</span></p>
                                    <p className={` ${isArabic ? 'arabic' : ''}`}> {t('HistoryofActionScreenContent.Timestamp')} <span>:</span> {item.lastUpdatedTime ? moment(item.lastUpdatedTime).format("DD MMM YYYY HH:mm ") : ""} </p>
                                </>
                            </Popup>
                            {width > 820 ?
                                <Tooltip>
                                    <>
                                        <p className="font-weight-bold lead">{item.shipName}</p>
                                        <p> {t('content.Destination')} : {item.destination}</p>
                                        <p className={` ${isArabic ? 'arabic' : ''}`}> {t('HistoryofActionScreenContent.Timestamp')} <span>:</span> {item.lastUpdatedTime ? moment(item.lastUpdatedTime).format("DD MMM YYYY HH:mm ") : ""} </p>
                                    </>
                                </Tooltip>
                                :
                                <></>
                            }
                        </Marker>
                    ))}
                </MapContainer>
            </>
        );
    }
}
function mapStateToProps(state) {
    return {
        mapData: state.MasterScreenReducer.mapData || [],
        ShipId: state.MasterScreenReducer.ShipData || 0,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}
export default withTranslation() (connect(mapStateToProps, mapDispatchToProps)(MapChart));
